import React from 'react';
import PropTypes from 'prop-types';
//Styles
import { useStyles } from 'components/sheets/AccountManageModuleSheets/AccountManageSheets.style';
//Mui components
import { Switch } from '@mui/material';

const ManagePeSheet = ({
    activeModule,
    setActiveModule,
}) => {

    const classes = useStyles();

    return <div className={classes.moduleManageContainer}>
        <div className={classes.activeModule}>
            <div className={classes.titleText}>
                Activer le module PE pour le compte
            </div>
            <Switch checked={activeModule} onChange={() => setActiveModule(!activeModule)} />
        </div>
    </div>;
};

ManagePeSheet.propTypes = {
    activeModule: PropTypes.bool,
    setActiveModule: PropTypes.func,
};

export default ManagePeSheet;
